<template>
    <svg :width="width" :height="height" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.99995 6.6001L5.09995 2.4001L1.19995 6.6001" stroke="white" stroke-linecap="square"/>
    </svg>
</template>
<script>
export default {
    name: 'AtomIcChevron',
    props: {
        width: {
            type: Number,
            default: 40
        },
        height: {
            type: Number,
            default: 40
        }
    },
}
</script>
